import { I18nComponente } from "@/types/gerais"

export const errosi18n: I18nComponente = {
  "pt-BR": {
    "400": {
      mensagem: "ocorreu um erro inesperado",
      detalhe: "O servidor não pode processar a requisição"
    },
    "401": {
      mensagem: "O servidor não pode processar a requisição"
    },
    "403": {
      mensagem: "O servidor não pode processar a requisição",
      detalhe: "sua sessão expirou, tente logar novamente"
    },
    "404": {
      mensagem: "Recurso não encontrado",
      detalhe: "Não foi possível localizar o recurso requisitado"
    },
    "406": {
      mensagem: "Não foi possível responder ao pedido",
      detalhe: "Por favor, verifique o preenchimento dos campos"
    },
    "409": {
      mensagem: "A requisição não pode ser processada"
    },
    "422": {
      mensagem: "Erro inesperado"
    },
    "500": {
      mensagem: "Ocorreu um erro crítico na api",
      detalhe: "O servidor está indisponível, entre em contato com a equipe de suporte",
    },
    "cancelado": {
      mensagem: "cancelado",
      detalhe: "requisição cancelada pelo usuário"
    }
  },
  "es-CO": {
    "400": {
      mensagem: "ocurrió un error inesperado",
      detalhe: "El servidor no puede procesar la solicitud"
    },
    "401": {
      mensagem: "El servidor no puede procesar la solicitud"
    },
    "403": {
      mensagem: "El servidor no puede procesar la solicitud",
      detalhe: "su sesión ha expirado, intente iniciar sesión nuevamente"
    },
    "404": {
      mensagem: "Recurso no encontrado",
      detalhe: "No se pudo encontrar el recurso solicitado"
    },
    "406": {
      mensagem: "No se pudo responder a la solicitud",
      detalhe: "Por favor, verifique el llenado de los campos"
    },
    "409": {
      mensagem: "La solicitud no puede ser procesada"
    },
    "422": {
      mensagem: "Error inesperado"
    },
    "500": {
      mensagem: "Se produjo un error crítico en la API",
      detalhe: "El servidor no está disponible, comuníquese con el equipo de soporte",
    },
    "cancelado": {
      mensagem: "cancelado",
      detalhe: "solicitud cancelada por el usuario"
    }
  },
}
